import Tool, { type ToolArgs } from '../../../tools/Tool';
import { Element, Transforms } from 'slate';
import type { Placement } from '@floating-ui/dom';

// Unlink a link card.
class ToolUnlinkCard extends Tool {
  static toolName = 'Remove link card';
  static iconClass = 'fa-solid fa-trash';

  static action({ editor, element }: ToolArgs): void {
    if (!editor) return;
    if (!editor.selection) return;

    // Remove the entire link card node instead of just unwrapping it
    Transforms.removeNodes(editor, {
      match: (n) => Element.isElement(n) && n.type === 'linkCard',
    });
  }

  static tooltipPlacement(): Placement {
    return 'bottom';
  }
}

export default ToolUnlinkCard;
